import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import { Carousel } from 'react-responsive-carousel'
import { DEFAULT_PROFILE_PIC_SRC } from './../../../constants'
import 'react-responsive-carousel/lib/styles/carousel.css'
import FontAwesome from 'react-fontawesome'

import mainConfig from './../../../config'

class Summary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailsShown: true
    }
  }

  componentDidMount() {
    if (window.innerWidth > 767) {
      this.setState({
        detailsShown: true
      })
    } else {
      this.setState({
        detailsShown: false
      })
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        this.setState({
          detailsShown: true
        })
      }
    })
  }

  viewDetails() {
    this.setState({
      detailsShown: !this.state.detailsShown
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => {
      if (window.innerWidth > 767) {
        this.setState({
          detailsShown: true
        })
      }
    })
  }

  render() {
    const { summary, user, t, tripGuru } = this.props

    let travelers

    if (!summary.travelers.length) {
      travelers = summary.partySize ? 'You + ' + summary.partySize : 'You'
    } else {
      travelers = summary.travelers.length ? 'You + ' + summary.travelers.length : 'You'
    }

    const amountOfPeople = this.props.getAmountOfPeople()

    const servicesSum = this.props.getServicesSum()

    let result = this.props.getTotalAmount() //summary.price * summary.daysCount * amountOfPeople + servicesSum

    const serviceFee = mainConfig.guruServiceFee * result

    result += serviceFee

    const imgSrc =
      user && user.plannerProfile && user.plannerProfile.photos && user.plannerProfile.photos[0]
        ? user.plannerProfile.photos[0].url
        : '/img/summary.jpg'
    return (
      <div className="summary">
        {this.props.user &&
        this.props.user.plannerProfile &&
        this.props.user.plannerProfile.photos &&
        this.props.user.plannerProfile.photos.length ? (
          <div className="finishPage__carousel">
            <Carousel showArrows={true} showStatus={false} showThumbs={false} autoPlay={true} emulateTouch={true}>
              {this.props.user.plannerProfile.photos.map((photo, index) => (
                <div className="carouselPhoto" key={index}>
                  <img src={photo.url} />
                </div>
              ))}
            </Carousel>
          </div>
        ) : (
          <div>Loading</div>
        )}
        <div className={this.state.detailsShown ? 'review' : 'hidden'}>
          <div className={this.props.summary.paymentType ? 'row' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <button className="action-button summary__action-button" onClick={this.props.saveBookingSteps}>
                {t('request_to_book')}
              </button>
            </div>
          </div>
          <h2 className="section title" style={{ marginBottom: 25 }}>
            {t('review_summary')}
          </h2>

          {tripGuru.User && (
            <div className="row summary__item">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('trip_guru')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">
                  {tripGuru.User.userProfile.firstName} {tripGuru.User.userProfile.lastName}
                </span>
              </div>
            </div>
          )}

          <div className="row summary__item">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('your_plan')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{this.props.summary.planTitle}</span>
            </div>
          </div>
          <div className="row summary__item">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('coming')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{travelers}</span>
            </div>
          </div>

          <div className={summary.group ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_group')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.group}</span>
            </div>
          </div>

          <div className={summary.tripTempo ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_tempo')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.tripTempo}</span>
            </div>
          </div>
          <div className={summary.requestedBudgetMin ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_budget_min')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">
                {summary.requestedBudgetMin} <FontAwesome name={`${summary.currency.toLowerCase()}`} />
              </span>
            </div>
          </div>
          <div className={summary.requestedBudgetMax ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_budget_max')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">
                {summary.requestedBudgetMax} <FontAwesome name={`${summary.currency.toLowerCase()}`} />
              </span>
            </div>
          </div>

          <div className={summary.tripBudgetTypeValue ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_budget_type')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.tripBudgetTypeValue}</span>
            </div>
          </div>

          <div className={summary.comments ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_comments')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.comments}</span>
            </div>
          </div>

          <div className={summary.categoryNames.length ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_activities')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">
                {summary.categoryNames.map((category, index) => (
                  <div key={index}>
                    <span className="summary__item__value">{category}</span>
                  </div>
                ))}
              </span>
            </div>
          </div>

          <div className={summary.paymentType ? 'summary__item row' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('summary_payment')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.paymentType}</span>
            </div>
          </div>

          <div className="summary__item row">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title show-mobile">{t('total')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">
                {`(${summary.price}`}
                <FontAwesome name={`${summary.currency.toLowerCase()}`} />
                {` X ${summary.daysCount}) X ` + amountOfPeople + ' = ' + summary.price * summary.daysCount * amountOfPeople}{' '}
                <FontAwesome name={`${summary.currency.toLowerCase()}`} />
              </span>
            </div>
          </div>

          <hr />

          <div className={summary.serviceNames.length ? 'summary__item' : 'hidden'}>
            <div>
              <h3 className="services-header">{t('summary_services')}</h3>
            </div>

            {summary.serviceNames.map((service, index) => (
              <div className="summary__item row" key={index}>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <span className="summary__item__value">{t(service.name)}</span>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                  <span className="summary__item__value">
                    <FontAwesome name={`${summary.currency.toLowerCase()}`} />
                    {service.price}
                  </span>
                </div>
              </div>
            ))}
            <hr />
          </div>

          <div className="row summary__item">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('service_fee')}:</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">
                  {serviceFee}
                  <FontAwesome name={`${summary.currency.toLowerCase()}`} />
              </span>
            </div>
          </div>
          
        </div>

        <div className="summary__item total-wrapper row">
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <span className="summary__item__title total-block hide-mobile">{t('total')}</span>

            <div className="show-mobile result-mobile">
              <span className="summary__item__value total">
                {result}
                <FontAwesome name={`${summary.currency.toLowerCase()}`} />
              </span>
              <button className="view-details" onClick={() => this.viewDetails()}>
                {t('view_details')}
              </button>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <span className="summary__item__value total hide-mobile">
              {result}
              <FontAwesome name={`${summary.currency.toLowerCase()}`} />
            </span>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('booking_steps'))

export default enhance(Summary)



// WEBPACK FOOTER //
// src/components/Guru/BookingSteps/Summary.jsx